import React, { useCallback, useEffect, useMemo, useState } from 'react';

import {
	Textarea,
	FormItem,
	Button,
	Space,
	Modal,
	ModalTitle,
	Textbox,
} from '@components';

import './EditAgendaItemModal.scss';
import { AgendaItem } from '@api';
import { cloneDeep } from 'lodash';

interface EditAgendaItemModalProps {
	closeModal: () => void,
	onSubmit: (item: AgendaItem) => void,
	agendaItem: AgendaItem,
}

function EditAgendaItemModal(props: EditAgendaItemModalProps): JSX.Element {
	const {
		closeModal,
		onSubmit,
		agendaItem,
	} = props;

	const [agendaItemText, setAgendaItemText] = useState<string>('');
	const [agendaItemSpeaker, setAgendaItemSpeaker] = useState<string>('');

	useEffect(() => {
		setAgendaItemText(agendaItem.text);
		if (agendaItem.speakers && agendaItem.speakers.length > 0) {
			setAgendaItemSpeaker(agendaItem.speakers[0]);
		}
	}, [setAgendaItemText, agendaItem]);

	const handleSubmit = useCallback((): void => {
		const item: AgendaItem = cloneDeep(agendaItem);
		item.text = agendaItemText;
		if (agendaItemSpeaker) {
			if (!item.speakers) {
				item.speakers = [];
			}
			item.speakers[0] = agendaItemSpeaker;
		}
		onSubmit(item);		
		closeModal();

	}, [agendaItemText, agendaItemSpeaker, agendaItem, closeModal, onSubmit]);

	const headerView = useMemo((): JSX.Element => {
		return (
			<div className="edit-agenda-modal__header">
				<ModalTitle onClose={closeModal}>
					Редактирование вопроса повестки
				</ModalTitle>
			</div>
		);
	}, [closeModal]);

	const footerView = useMemo(() => {
		return (
		<Space>
			<Button theme="primary" onClick={handleSubmit}>
				Сохранить
			</Button>
			<Button onClick={closeModal}>
				Отменить
			</Button>
		</Space>
		);
	}, [handleSubmit, closeModal]);

	return (
		<Modal
			className="edit-agenda-modal"
			header={headerView}
			footer={footerView}
			isOpen
		>
			<div className="edit-agenda-modal__content">
				<FormItem>
				<Textarea
						autoFocus
						className="edit-agenda-modal__textfield"
						value={agendaItemText}
						placeholder="Текст вопроса повестки"
						onValueChange={(val) => setAgendaItemText(val)}
					/>
				</FormItem>
				<FormItem label="Докладчик">
					<Textbox
						value={agendaItemSpeaker}
						onValueChange={(val) => setAgendaItemSpeaker(val)}
					/>
				</FormItem>
			</div>
		</Modal>
	);
}

export {EditAgendaItemModal};